import { isMobile } from "react-device-detect";
import { Link, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";

import logoBranco from "../../images/logoBranco.svg";
import logoColorido from "../../images/logoColorido.svg";
import toggleMenu from "../../images/Icons/menuIcon.svg";
import userIcon from "../../images/Icons/userIcon.svg";
import cartIcon from "../../images/Icons/cartIcon.svg";
import { FranchiseContext } from "./../../contexts/franchiseContext";
import { AuthUserContext } from "./../../contexts/authUserContext";
import { CartContext } from "./../../contexts/cartContext";

import "./nav.scss";

function Nav() {
  const { franchise } = useContext(FranchiseContext);
  const { authUser } = useContext(AuthUserContext);

  const location = useLocation();

  const { cartItemsQuantity } = useContext(CartContext);

  const authUserInsistence = authUser?.id ? authUser : JSON.parse(localStorage.getItem("authUser"));

  const showLocationInformation = location.pathname !== "/";

  return (
    <div className="nav">
      {showLocationInformation ? (
        <nav className="navbar w-100">
          <div
            className={`container justify-content-between min-vw-100 mx-0 ${isMobile && showLocationInformation ? "p-0" : ""
              }`}
          >
            <div className="d-flex justify-content-between align-items-center">
              <button
                className="border border-0 hamburguer"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#fullSideBar"
                aria-controls="fullSideBar"
              >
                <img className="menu-icon" src={toggleMenu} alt="Menu" />
              </button>
              <Link className="navbar-brand" to={"/"}>
                <img className="logo-colorido" src={logoColorido} alt="Logo" />
              </Link>
            </div>
            <div className="city-choose">
              <button
                type="button"
                className="btn d-flex flex-column justify-content-start"
              >
                <p className="title">Cidade:</p>
                <p className="city">{franchise.name}</p>
              </button>
            </div>
            <div
              className={`d-flex justify-content-center align-items-center text-decoration-none ${isMobile ? "ms-auto" : ""
                }`}
            >
              <Link
                type="button"
                to={authUserInsistence?.id ? `my-account` : "./login"}
                className="btn d-flex justify-content-center align-items-center border border-2 border-radius-8 px-4 user-acount"
              >
                <img src={userIcon} alt="Logo" />
                <p className="text" style={{ marginLeft: "10px" }}>
                  {authUserInsistence?.name ? authUserInsistence.name : "Minha conta"}
                </p>
              </Link>
              <Link
                type="button"
                to={"./carrinho"}
                className="btn d-flex justify-content-center align-items-center"
              >
                <img src={cartIcon} alt="Logo" />
                <span
                  className="rounded-5 items-count d-flex justify-content-center align-items-center mx-1"
                >
                  {cartItemsQuantity}
                </span>
              </Link>
            </div>
          </div>
        </nav>
      ) : (
        <nav className="navbar w-100 location-notSelected">
          <div className="container justify-content-start align-items-center ms-0">
            <button
              className="border border-0 hamburguer"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#fullSideBar"
              aria-controls="fullSideBar"
            >
              <img className="menu-icon" src={toggleMenu} alt="Menu" />
            </button>
            <Link to={"/"} className="navbar-brand ms-5">
              {isMobile ? (
                <img
                  src={logoColorido}
                  alt="Bootstrap"
                  width="220"
                  height="36"
                />
              ) : (
                <img src={logoBranco} alt="Bootstrap" width="280" height="45" />
              )}
            </Link>
          </div>
        </nav>
      )}

      <div
        className="offcanvas offcanvas-top h-100 py-1"
        style={{ background: "var(--azul)" }}
        tabIndex="-1"
        id="fullSideBar"
        aria-labelledby="offcanvasTopLabel"
      >
        <div className="offcanvas-header d-flex justify-content-center p-0">
          <button
            className="border border-0 close-fullSide-button"
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <p className="m-0">X</p>
          </button>
        </div>
        <div className="offcanvas-body p-0">
          <div className="w-100 h-100 d-flex justify-content-center align-items-center side-body">
            <ul className="w-100 p-0 m-0">
              <li>
                <Link to={"/"} className="w-100 d-flex justify-content-center">
                  INÍCIO
                </Link>
              </li>
              <li>
                <Link
                  to={"/brinquedos-adoleta"}
                  className="w-100 d-flex justify-content-center"
                >
                  BRINQUEDOS
                </Link>
              </li>
              <li>
                <Link
                  to={"/quem-somos"}
                  className="w-100 d-flex justify-content-center"
                >
                  QUEM SOMOS
                </Link>
              </li>
              <li>
                <Link
                  to={"/duvidas-frequentes"}
                  className="w-100 d-flex justify-content-center"
                >
                  DÚVIDAS FREQUENTES
                </Link>
              </li>
              <li>
                <Link to={"/"} className="w-100 d-flex justify-content-center">
                  MEUS PEDIDOS
                </Link>
              </li>
              <li>
                <Link
                  to={"/seja-um-franqueado"}
                  className="w-100 d-flex justify-content-center"
                >
                  SEJA UM FRANQUEADO
                </Link>
              </li>
              <li>
                <Link
                  to={"/contato"}
                  className="w-100 d-flex justify-content-center"
                >
                  CONTATO
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;
